module.exports = __webpack_public_path__ + "static/media/multiverse7.33f1027f.png";